import {Box, TextField, Typography} from '@mui/material';

type Props = {
  value: string;
  id: number;
  onChange: (text: string) => void;
  label?: string;
  disabled?: boolean;
};

const TimedMsgRequestContentMessageForm = ({
  value,
  id,
  onChange,
  label,
  disabled = false,
}: Props) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  const isEmpty = !value?.trim();

  if (disabled && isEmpty) {
    return (
      <Box className='w-full'>
        <Typography variant='body2'>No script available</Typography>
      </Box>
    );
  }

  return (
    <Box className='w-full'>
      <TextField
        name={`message-${id}`}
        fullWidth
        multiline
        rows='4'
        placeholder={`Enter ${label ?? 'Message'} here`}
        required
        value={value}
        onChange={handleChange}
        variant='outlined'
        sx={{
          backgroundColor: 'var(--blue-variant15)',
          '& fieldset': {
            borderColor: '#bdbdbd',
          },
        }}
        disabled={disabled}
      />
      {!disabled && (
        <div className='text-white-50 italic mt-3 text-13'>
          The message must be atleast 10 characters long
        </div>
      )}
    </Box>
  );
};

export default TimedMsgRequestContentMessageForm;
